/**
 * 👋 Hey there!
 * This file is the starting point for your new WordPress/Gatsby site! 🚀
 * For more information about what this file is and does, see
 * https://www.gatsbyjs.com/docs/gatsby-config/
 *
 */
// require("dotenv").config()
// const adapter = require("gatsby-adapter-netlify").default


module.exports = {
  siteMetadata: {
    // If you didn't use the resolveSiteUrl option this needs to be set
    siteUrl: `https://www.jamulcasino.com`,
  },
  // flags: {
  //   DEV_SSR: true
  // },
  // adapter: adapter({
  //   imageCDN: true,
  // }),
  /**
   * Adding plugins to this array adds them to your Gatsby site.
   *
   * Gatsby has a rich ecosystem of plugins.
   * If you need any more you can search here: https://www.gatsbyjs.com/plugins/
   */
  plugins: [
    {
      /**
       * First up is the WordPress source plugin that connects Gatsby
       * to your WordPress site.
       *
       * visit the plugin docs to learn more
       * https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-source-wordpress/README.md
       *
       */
      resolve: `gatsby-source-wordpress`,
      options: {
        // the only required plugin option for WordPress is the GraphQL url.
        url:
          process.env.WPGRAPHQL_URL ||
          `https://cms.jamulcasinosd.com/graphql`,
        auth: {
          htaccess: {
            username: process.env.HTTPBASICAUTH_USERNAME,
            password: process.env.HTTPBASICAUTH_PASSWORD,
          }
        },
        develop: {
          hardCacheMediaFiles: true,
        },
        production: {
          // hardCacheMediaFiles: true,
          allow404Images: true,
          allow401Images: true,
        },
        schema: {
          timeout: 60000,
          // perPage: 50, // Adjust this as needed, default is 100
          // requestConcurrency: 5, // Adjust this if rate-limiting is an issue, default is 15
        },
        debug: {
          graphql: {
            showQueryOnError: true,
            showQueryVarsOnError: true,
          },
          preview: true,
        },
        verbose: true,
        presets: null,
        html: {
          useGatsbyImage: false,
          createStaticFiles: false,
        },
        type: {
          MediaItem: {
            localFile: {
              excludeByMimeTypes: [`video/mp4`, `video/webm`],
              // requestConcurrency: 50, // Default 100
            },
          },
        },
      },
    },

    /**
     * We need this plugin so that it adds the "File.publicURL" to our site
     * It will allow us to access static url's for assets like PDF's
     *
     * See https://www.gatsbyjs.org/packages/gatsby-source-filesystem/ for more info
     */
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `assets`,
        path: `${__dirname}/content/assets`,
      },
    },

    /**
     * The following two plugins are required if you want to use Gatsby image
     * See https://www.gatsbyjs.com/docs/gatsby-image/#setting-up-gatsby-image
     * if you're curious about it.
     */
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    `gatsby-plugin-image`,
    {
      // See https://www.gatsbyjs.com/plugins/gatsby-plugin-manifest/?=gatsby-plugin-manifest
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `Jamul Casino Resort San Diego`,
        short_name: `Jamul Casino Resort`,
        start_url: `/`,
        background_color: `#ffffff`,
        theme_color: `#007378`,
        display: `minimal-ui`,
        icon: `content/assets/favicon.svg`,
      },
    },

    // See https://www.gatsbyjs.com/plugins/gatsby-plugin-react-helmet/?=gatsby-plugin-react-helmet
    `gatsby-plugin-react-helmet`,

    /**
     * this (optional) plugin enables Progressive Web App + Offline functionality
     * To learn more, visit: https://gatsby.dev/offline
     */
    // `gatsby-plugin-offline`,

    // Netlify
    // {
    //   resolve: `gatsby-plugin-netlify`,
    //   options: {
    //     headers: {
    //       "/private/*": [
    //         "Basic-Auth: jamulcasino:sandiego",
    //       ],
    //     },
    //   },
    // },
    // {
    //   resolve: `gatsby-adapter-netlify`,
    //   options: {
    //     IMAGE_CDN: true, // Example option
    //   },
    // },

    // TailwindCSS
    'gatsby-plugin-postcss',

    // Algolia Search (+ Filters)
    {
      resolve: `gatsby-plugin-algolia`,
      options: {
        appId: process.env.GATSBY_ALGOLIA_APP_ID || "TQGFISJST2",
        apiKey: process.env.ALGOLIA_ADMIN_KEY || "f6acef05ed2ff64d813f9932740d0fdb",
        queries: require("./src/utils/algolia-queries"),
      },
    },

    // Sitemap
    {
      resolve: `gatsby-plugin-sitemap`,
      options: {
        excludes: ["/private/", "/private/*", '/sponsorship-request-form/thank-you/', '/thank-you/', '/thank-you-newsletter/'],
      }
    }
  ],
}
